/* eslint-disable max-lines */
import { initialStateMock } from '@shared/utils/test.utils';
import { CAMPAIGNS_MOCK } from '@domain/dashboard/campaigns/campaigns.mock';

export const tagGroupsMock = {
    tagGroups: {
        currentSegments: {
            loadState: 'success',
            data: [
                {
                    slug: 'standard',
                    id: null,
                    name: 'Campaign',
                    created_by: null,
                    is_fb_tagged_level_adset: false,
                    client: '517',
                },
                {
                    slug: 'campaign_type',
                    id: null,
                    name: 'Campaign Type',
                    created_by: null,
                    is_fb_tagged_level_adset: false,
                    client: '517',
                },
                {
                    id: 67,
                    name: 'test 5',
                    created_by: 788,
                    client_id: 517,
                    slug: 'test-5',
                    is_fb_tagged_level_adset: false,
                },
                {
                    id: 69,
                    name: 'teste 7',
                    created_by: 788,
                    client_id: 517,
                    slug: 'teste-7',
                    is_fb_tagged_level_adset: false,
                },
            ],
            error: null,
            selectedGroup: {
                slug: 'standard',
                id: null,
                name: 'Campaign',
                created_by: null,
                is_fb_tagged_level_adset: false,
                client_id: '615',
            },
        },
    },
};

export const onlyOneTagGroupMock = {
    ...initialStateMock(false),
    segments: {
        currentSegments: {
            loadState: 'success',
            data: [
                {
                    id: 69,
                    name: 'teste 7',
                    created_by: 788,
                    client_id: 517,
                    slug: 'teste-7',
                    is_fb_tagged_level_adset: false,
                },
            ],
            error: null,
            selectedGroup: {
                slug: 'standard',
                id: null,
                name: 'Campaign',
                created_by: null,
                is_fb_tagged_level_adset: false,
                client_id: '615',
            },
        },
    },
    dashboard: {
        campaigns: CAMPAIGNS_MOCK.campaigns,
    },
    campaigns: CAMPAIGNS_MOCK.campaigns,
};

export const oneTagGroupsMock = {
    data: [
        {
            id: 69,
            name: 'teste 7',
            created_by: 788,
            client_id: 517,
            slug: 'teste-7',
            is_fb_tagged_level_adset: false,
        },
    ],
};

export const twoTagGroupsMock = {
    data: [
        {
            id: 69,
            name: 'teste 7',
            created_by: 788,
            client_id: 517,
            slug: 'teste-7',
            is_fb_tagged_level_adset: false,
        },
        {
            id: 69,
            name: 'teste 8',
            created_by: 788,
            client_id: 517,
            slug: 'teste-8',
            is_fb_tagged_level_adset: false,
        },
    ],
};

export const CAMPAIGNS_MOCK_TO_TOP_FOUR = [
    {
        campaign_id: '45455',
        campaign_name: 'Cinema',
        name: 'Cinema',
        platform: 'google_ads',
        cost: 400,
        status: 'enabled',
        tags: [
            {
                group_name: 'Campaign Type 1',
                group_slug: 'campaign_type',
                group_id: null,
                tag: {
                    value: 'Facebook',
                    label: 'Facebook',
                },
            },
        ],
    },
    {
        campaign_id: '889293791',
        campaign_name: 'Cinema 1',
        name: 'Cinema 1',
        platform: 'google_ads',
        cost: 20,
        status: 'enabled',
        tags: [
            {
                group_name: 'Campaign Type 2',
                group_slug: 'campaign_type',
                group_id: null,
                tag: {
                    value: 'Display',
                    label: 'Display',
                },
            },
        ],
    },
    {
        campaign_id: '8494612',
        campaign_name: 'Cinema 2',
        name: 'Cinema 2',
        platform: 'google_ads',
        cost: 25,
        status: 'enabled',
        tags: [
            {
                group_name: 'Campaign Type 3',
                group_slug: 'campaign_type',
                group_id: null,
                tag: {
                    value: 'Display',
                    label: 'Display',
                },
            },
        ],
    },
    {
        campaign_id: '454546',
        campaign_name: 'Cinema 3',
        name: 'Cinema 3',
        platform: 'google_ads',
        cost: 25,
        status: 'enabled',
        tags: [
            {
                group_name: 'Campaign Type 4',
                group_slug: 'campaign_type',
                group_id: null,
                tag: {
                    value: 'Display',
                    label: 'Display',
                },
            },
        ],
    },
    {
        campaign_id: '4545',
        campaign_name: 'Cinema 3',
        name: 'Cinema 3',
        platform: 'google_ads',
        cost: 25,
        status: 'enabled',
        tags: [
            {
                group_name: 'Campaign Type 5',
                group_slug: 'campaign_type',
                group_id: null,
                tag: {
                    value: 'Display',
                    label: 'Display',
                },
            },
        ],
    },
    {
        campaign_id: '4545555',
        campaign_name: 'Cinema 4',
        name: 'Cinema 4',
        platform: 'google_ads',
        cost: 25,
        status: 'enabled',
        tags: [
            {
                group_name: 'Campaign Type 6',
                group_slug: 'campaign_type',
                group_id: null,
                tag: {
                    value: 'Display',
                    label: 'Display',
                },
            },
        ],
    },
    {
        campaign_id: '4545556',
        campaign_name: 'Cinema 5',
        name: 'Cinema 5',
        platform: 'google_ads',
        cost: 100,
        status: 'enabled',
        tags: [
            {
                group_name: 'Campaign Type 7',
                group_slug: 'campaign_type',
                group_id: null,
                tag: {
                    value: 'Express',
                    label: 'Express',
                },
            },
        ],
    },
    {
        campaign_id: '5454',
        campaign_name: 'Cinema 6',
        name: 'Cinema 6',
        platform: 'google_ads',
        cost: 100,
        status: 'enabled',
        tags: [
            {
                group_name: 'Campaign Type 8',
                group_slug: 'campaign_type',
                group_id: null,
                tag: {
                    value: 'Search',
                    label: 'Search',
                },
            },
        ],
    },
    {
        campaign_id: '546521',
        campaign_name: 'Cinema 7',
        name: 'Cinema 7',
        platform: 'google_ads',
        cost: 100,
        status: 'enabled',
        tags: [
            {
                group_name: 'Campaign Type 9',
                group_slug: 'campaign_type',
                group_id: null,
                tag: {
                    value: 'Search',
                    label: 'Search',
                },
            },
        ],
    },
    {
        campaign_id: '84654612',
        campaign_name: 'Cinema 8',
        name: 'Cinema 8',
        platform: 'google_ads',
        cost: 100,
        status: 'enabled',
        tags: [
            {
                group_name: 'Campaign Type 10',
                group_slug: 'campaign_type',
                group_id: null,
                tag: {
                    value: 'Search',
                    label: 'Search',
                },
            },
        ],
    },
];

export const EXPECT_MOCK_TO_TOP_FOUR = {
    Facebook: [{ campaign_id: '45455', platform: 'google_ads' }],
    Display: [
        { campaign_id: '889293791', platform: 'google_ads' },
        { campaign_id: '8494612', platform: 'google_ads' },
        { campaign_id: '454546', platform: 'google_ads' },
        { campaign_id: '4545', platform: 'google_ads' },
        { campaign_id: '4545555', platform: 'google_ads' },
    ],
    Express: [{ campaign_id: '4545556', platform: 'google_ads' }],
    Search: [
        { campaign_id: '5454', platform: 'google_ads' },
        { campaign_id: '546521', platform: 'google_ads' },
        { campaign_id: '84654612', platform: 'google_ads' },
    ],
};
